import {Component, Object3D, property, Type} from '@wonderlandengine/api';

import {vec3, quat2, vec2} from 'gl-matrix';
import {State} from './classes/gameState.js';
import {Sounds} from './utils/soundfx-player.js';
import {storageSpace13} from './globals.js';
import {WLUtils} from './utils/WLUtils.js';
import {GameProgress, GameProgressItems} from './classes/GameProgress.js';

export class PickTarget extends Component {
    static TypeName = 'pick-target';

    @property.object({required: true})
    allowedPickerMeshObject!: Object3D;

    @property.object({required: true})
    notAllowedPickerMeshObject!: Object3D;

    @property.int(1)
    floorGroup!: number;

    @property.object({required: true})
    player!: Object3D;

    pickingActive: boolean;
    input: any;
    initialized: boolean;
    hitSpot: any;
    hitObject: any;
    indicatorHidden: any;

    canTrigger() {
        return true;
    }

    pickingAllowed(obj, x, y, z) {
        let tags = obj.getComponent('tags');
        if (!tags) {
            return false;
        }
        if (storageSpace13.gameState.state !== State.Playing) {
            if (tags.hasTag('button')) {
                return true;
            }
            return false;
        }

        if (tags.hasTag('floor')) {
            return storageSpace13.levelState.canTeleportToPosition(x, y, z);
        }
        return true;
    }

    picked(obj, x, y, z) {
        let tags = obj.getComponent('tags');
        if (!tags) return;
        let position = storageSpace13.gameState.playerPosition;
        //this.player.getTranslationWorld(position);
        switch (true) {
            case tags.hasTag('floor'):
                storageSpace13.soundFxPlayer.playSound(Sounds.teleport);
                storageSpace13.gameState.playerPosition = [x, position[1], z];
                GameProgress.instance.recordAdditive(GameProgressItems.totalTeleports, 1);
                break;
            case tags.hasTag('button'):
                break;
            case tags.hasTag('box'):
                let bc = obj.parent.getComponent('box-controller');
                bc.slide();
                GameProgress.instance.recordAdditive(GameProgressItems.totalMoves, 1);
                break;
        }
    }

    start() {
        this.pickingActive = false;
        this.input = this.object.getComponent('input');

        // throw error or warning when no input is on the mesh.
        WLUtils.setActive(this.allowedPickerMeshObject, false);
        WLUtils.setActive(this.notAllowedPickerMeshObject, false);
        this.initialized = true;
    }

    update(dt) {
        let xrInputSource = this.input.xrInputSource;
        if (!this.initialized || !xrInputSource) {
            return;
        }
        const buttonPressed = xrInputSource.gamepad.buttons[0].pressed;
        if (buttonPressed && this.pickingActive === false && this.canTrigger()) {
            this.pickingActive = true;
        }

        if (!buttonPressed && this.pickingActive === true) {
            this.pickingActive = false;
            if (this.hitSpot) {
                let hitPos = [];
                this.hitObject.getTranslationWorld(hitPos);
                let x = hitPos[0];
                let y = hitPos[2];
                if (this.pickingAllowed(this.hitObject, x, 0, y)) {
                    this.picked(this.hitObject, x, 0, y);
                }

                if (!this.indicatorHidden) {
                    WLUtils.setActive(this.allowedPickerMeshObject, false);
                    WLUtils.setActive(this.notAllowedPickerMeshObject, false);
                    this.indicatorHidden = true;
                }
                this.hitSpot = undefined;
            }
        }

        if (this.pickingActive) {
            let origin = vec3.create();
            quat2.getTranslation(origin, this.object.transformWorld);

            let quat = this.object.transformWorld;

            let forwardDirection = vec3.create();
            vec3.transformQuat(forwardDirection, [0, 0, -1], quat);
            let rayHit = this.engine.scene.rayCast(origin, forwardDirection, 1 << this.floorGroup);

            if (rayHit.hitCount > 0) {
                if (this.indicatorHidden) {
                    this.indicatorHidden = false;
                }
                this.hitSpot = rayHit.locations[0];
                this.hitObject = rayHit.objects[0];
                let hitPos = [];
                this.hitObject.getTranslationWorld(hitPos);
                let x = hitPos[0];
                let y = hitPos[2];
                this.showIndicator(this.hitObject, x, 0, y);
            } else {
                if (!this.indicatorHidden) {
                    this.hideIndicator();
                    this.indicatorHidden = true;
                }
                this.hitSpot = undefined;
                this.hitObject = undefined;
            }
        }
    }

    hideIndicator() {
        WLUtils.setActive(this.allowedPickerMeshObject, false);
        WLUtils.setActive(this.notAllowedPickerMeshObject, false);
    }

    showIndicator(obj, x, y, z) {
        let tags = obj.getComponent('tags');
        if (!tags) return;
        switch (true) {
            case tags.hasTag('floor'):
                if (this.pickingAllowed(obj, x, y, z)) {
                    WLUtils.setActive(this.allowedPickerMeshObject, true);
                    WLUtils.setActive(this.notAllowedPickerMeshObject, false);
                    this.notAllowedPickerMeshObject.setTranslationWorld([1000, 1000, 1000]);
                    this.allowedPickerMeshObject.resetTranslationRotation();
                    this.allowedPickerMeshObject.translate([x, 0.01, z]);
                } else {
                    WLUtils.setActive(this.allowedPickerMeshObject, false);
                    WLUtils.setActive(this.notAllowedPickerMeshObject, true);
                    this.allowedPickerMeshObject.setTranslationWorld([1000, 1000, 1000]);
                    this.notAllowedPickerMeshObject.resetTranslationRotation();
                    this.notAllowedPickerMeshObject.translate([x, 0.01, z]);
                }
                break;
            case tags.hasTag('button'):
                //   let buttonController = obj.getComponent('button-controller');
                //   if(buttonController){
                //     buttonController.hover();
                //   }
                break;
            case tags.hasTag('box'):
                // let bc = obj.parent.getComponent('box-controller');
                // bc.slide();
                break;
        }
    }
}
